import $ from 'jquery'
import Vue from "vue";
const vueHeader = {};

vueHeader.init = () => {
    $("body").addClass("is-loaded");
    window.Menu = new Vue({
        el: "#header",
        delimiters: ['${', '}'],
        data: {
            isReduced: false,
            navOpened: false,
            searchOpened: false,
            isMobile:false
        },
        methods: {
            reduceHeader: function() {
                this.isReduced = true;
                $('body').addClass('header-fixed');
            },
            expandHeader: function() {
                this.isReduced = false;
                $('body').removeClass('header-fixed');
            },
            openNav: function() {
                this.closeSearch();
                this.navOpened = true;
                $('body').addClass("no-scroll nav-open");
                if (this.isMobile) {
                    this.searchOpened = true;
                    // $('body').removeClass("open-search"); REPASAR!!!!
                }
                if (this.isReduced) {
                    $('body').addClass("nav-open");
                    $('.h-nav').addClass("h-fixed");
                }
            },
            closeNav: function() {
                this.navOpened = false;
                this.searchOpened = false;
                $('body').removeClass("no-scroll nav-open");
                if (this.isMobile) {
                    // $('body').removeClass("open-search"); REPASAR!!!!
                }
                if (this.isReduced) {
                    $('body').removeClass("nav-open");
                    $('.h-nav').removeClass("h-fixed");
                }
            },
            toggleNav: function() {
                this.navOpened ? this.closeNav() : this.openNav();
            },
            openSearch: function() {
                // this.$refs.search.focus();
                this.navOpened = false;
                this.searchOpened = true;
                $('body').addClass("open-search"); //REPASAR!!!!
                $('body').removeClass("nav-open");
                if (this.isMobile) {
                    $('html').addClass("no-scroll");
                }
            },
            closeSearch: function() {
                this.searchOpened = false;
                $('body').removeClass("open-search"); //REPASAR!!!!
                if (this.isMobile) {
                    $('html').removeClass("no-scroll");
                }
            },
            toggleSearch: function() {
                this.searchOpened ? this.closeSearch() : this.openSearch();
            },
            openSubNav: function(event) {
                if (!this.isMobile) {
                    $(event.target).next().slideDown();
                }
            },
            closeSubNav: function(event) {
                if (!this.isMobile) {
                    $(event.target).children('ul').slideUp();
                }
            }
        },
        created: function() {
            var _this = this;

            //Control menú fixed
            //Edit variables:
            var headerToFix = 'header';
            var breakpoint = 769;
            var adjustPadding = 48;
            var controlMenuClass = 'home'; // (Cambiar del body al menú DE $('body').hasClass(controlMenuClass) A $('HEADER').hasClass(controlMenuClass) ) 

            var headerToFixTop = $(headerToFix).offset().top;
            var headerToFixHeight = $(headerToFix).outerHeight();
            var headerToFixBottom = headerToFixTop + headerToFixHeight + adjustPadding;
            var headerReduced = $('#header').hasClass('is-reduced');
            var isStaticPage = $('body').hasClass('static');
            $(window).on('load scroll resize', function () {
                var scrollTop = $(window).scrollTop();
                // console.log("headerToFixTop: " + headerToFixTop + " headerToFixHeight: " + headerToFixHeight  + " headerToFixBottom: " + headerToFixBottom + " Header Reduced: " + headerReduced  + " Adjust Padding: " + adjustPadding );

                if ($(window).width() > breakpoint) {
                    if (scrollTop >= headerToFixBottom || headerReduced) {
                        _this.reduceHeader();
                        if ($('body').hasClass(controlMenuClass)) {
                            $(".cscontent").css({
                                'paddingTop': headerToFixBottom
                            });
                        }
                    } else {
                        _this.expandHeader();
                        if ($('body').hasClass(controlMenuClass)) {
                            $(".cscontent").css({
                                'paddingTop': 0
                                //transition : 'all 0s ease-out'
                            });
                        }
                    }
                }
            }).trigger("scroll");

            // $(window).on('resize', function () {
            //     if ($(window).width() <= 769) {
            //         if( !_this.isReduced ) {
            //             _this.reduceHeader();
            //         }
            //     } else {
            //         if( _this.isReduced ) {
            //             _this.expandHeader();
            //         }
            //     }
            // } );

            if ($(window).width() < 769) {
                this.isReduced = true;
                this.navOpened = false;
                this.isMobile = true;
            }
            // END Control menú fixed
        }
    });
};

export default vueHeader;
